/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import { Breakpoint } from 'react-socks';

class SocialEditorTabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            detailUrl: (props.appName === "dlvr") ? "/config/socials/detail/" : "/socials/detail/",
            configUrl: (props.appName === "dlvr") ? "/config/social/" : "/socials/",
            listUrl: (props.appName === "dlvr") ? "/config/socials" : "/socials/",
        };

        this.viewSocialLog = this.viewSocialLog.bind(this);

    }


    viewSocialLog(e) {

        e.preventDefault();
        this.props.router.navigate(this.state.configUrl +  this.props.router.params.socialId + '/log');

    }

	render() {

		let socialClass = classnames('inline-left'),
			socialTab = null,
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.socialType)],
            tabAction = null,
            globalAction = null,
            tabClass = '',
            socialLabel = this.props.socialLabel;

        if (this.props.router.location.pathname.match(/log$/)) {
            globalAction = (
                <Link to={this.state.configUrl + this.props.router.params.socialId}>
                    <span className="editor-title label-left">
                        Global Settings
                    </span>
                </Link>
            );
        } else {
            globalAction = (
                <span className="editor-title label-left active">
                    Global Settings
                </span>
            );
            tabAction = this.viewSocialLog;
        }

        if (this.props.appName === "client") {
            globalAction = null;
        }


        tabClass = classnames('editor-title-tab', {
            'tab-active': (tabAction === null) ? true : false
        });

		return (
			<div className="editor-control-bar">
                <div className="editor-flex-wrapper">
                    <span className="editor-title label-left padded">
    					<Link to={this.state.listUrl} className="breadcrumb">Your Socials</Link>
    				</span>
    				<i className="fa fa-angle-right editor-title-icon"></i>
                    <span className="editor-title label-left social-name" alt={this.props.socialLabel} title={this.props.socialLabel}>
                        <Link to={this.state.detailUrl + this.props.router.params.socialId}>
                            <span className="va-helper"></span>
                            <Icon />
            	   			<span>{socialLabel}</span>
                        </Link>
        	   		</span>
                    <Breakpoint desktop only>
                        {globalAction !== null ? (<i className="fa fa-angle-right editor-title-icon"></i>) : null}
                        {globalAction}
                        <div className="editor-title-tabs">
        					<div className={tabClass} data-tab="status" onClick={tabAction} role="button" aria-label="view error log">
        						<i className="fa fa-history"></i> Social Error Log
        					</div>
        				</div>
                    </Breakpoint>
                </div>
                <Breakpoint mobile only>
                    <div className="mobile-social-functions">
                        {globalAction}
                        <div className="editor-title-tabs">
        					<div className={tabClass} data-tab="status" onClick={tabAction} role="button" aria-label="view error log">
        						<i className="fa fa-history"></i> Social Error Log
        					</div>
        				</div>
                    </div>
                </Breakpoint>
		   </div>
		);
	}

};

SocialEditorTabs.displayName = "SocialEditorTabs";

SocialEditorTabs.propTypes = {
    selected: PropTypes.string,
    feedLink: PropTypes.string
};

SocialEditorTabs.defaultProps = {
    socialType: 0,
    socialLabel: ''
};

export default SocialEditorTabs;
